import { useCallback } from 'react';
import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';

interface FundCustomQuestionAnswer {
  question: number;
  answer: string;
}

interface FundCustomQuestionAnswersRequest {
  answers: FundCustomQuestionAnswer[];
}

export const useSubmitFundCustomQuestionAnswers = () => {
  const [fetch, response] = useRequest();

  const submitFundCustomQuestionAnswers = useCallback(
    (projectFundMatchId: number, data: FundCustomQuestionAnswersRequest) =>
      fetch(API.paths.fund_custom_questions_answers(projectFundMatchId), 'post', { data }),
    [fetch],
  );

  return [submitFundCustomQuestionAnswers, response] as const;
};
